// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  fetchWrapper,
  postWrapper,
} from 'helpers/api'

export const fetchUserAnalysesStatuses = userId => fetchWrapper(`/users/${userId}/analysis-statuses`)

// gets a summary of users, only username and userId
export const fetchUsers = (query = '') => fetchWrapper(`/users${query}`)

// the API will respond with a newly generated JWT token which will be used
// to authorize the user's session.
export const postLegacyToken = token => postWrapper(`/users${token}`)

// posts the stored JWT token to get a new one.
export const postRenewJWT = () => postWrapper('/users/renew-token')

export const postUserLogin = body => postWrapper('/users/login', body)
